<div *ngIf="(state | async)[component].count === 0" class="uk-text-center" i18n="@@noResults">
  Results have not been found. Change searching criteria, please.
</div>
